interface RatingPropsNPS {
    value: number;
    color: string;
}

export const maxRatingNPS: RatingPropsNPS[] = [
    {value: 0, color: "#F52426"},
    {value: 1, color: "#F72A2C"},
    {value: 2, color: "#F93C3D"},
    {value: 3, color: "#F39015"}, 
    {value: 4, color: "#F59F34"},
    {value: 5, color: "#F8CA20"}, 
    {value: 6, color: "#F5C314"},
    {value: 7, color: "#84CA20"},
    {value: 8, color: "#72B61B"}, 
    {value: 9, color: "#13C33E"},
    {value: 10, color: "#06981F"}
]